import { Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { Review } from '../../model/Review';
import { FeedbackSection, RevalidationItemTypeConfig } from '../../model/RevalidationItemTypeConfig';
import { revalidationItemTypes } from '../../model/revalidationItemTypes';
import { ReviewService } from '../../service/review.service';
import { ActivatedRoute, Router } from '@angular/router';

import { UserService } from '../../../core/service/user.service';
import { CaseSplitPipe } from '../../../shared/pipe/CaseSplit.pipe';
import { ReviewStage } from '../../model/ReviewStage';
import { ReviewerRole } from '../../model/ReviewerRole';
import { FeedbackConfirmation } from '../../model/FeedbackConfirmation';
import { FeedbackApproval } from '../../model/FeedbackApproval';
import { ReviewView } from '../../model/ReviewView';
import { cloneDeep } from 'lodash-es';

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: ['../review.scss', './reviewDetail.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReviewComponent implements OnInit {
  reviewId: string;
  review!: Review;
  RevalidationItemTypeConfig!: RevalidationItemTypeConfig;
  sections!: Array<RevalidationItemTypeConfig>;
  revalidationItemTypes = revalidationItemTypes;
  selected: RevalidationItemTypeConfig | FeedbackSection | undefined;
  ReviewerRole = ReviewerRole;
  selectedFeedback: Review['feedback'] | undefined;

  selectedIndex = 0;
  helpVisible = false;
  items: Review['entries'] = [];
  chatVisible = false;
  chatOffset = -400;
  loading = false;
  approving = false;
  rejecting = false;
  excluding = false;
  shouldexcludedFromPublish: boolean | undefined;
  saving = false;
  title = '';
  readonly = false;
  showHelp = false;
  @ViewChild('rejectionReasonRef',) rejectionReasonRef!: ElementRef;
  stage;
  renewalDate = '';
  cohortId;
  isQA: boolean | undefined;
  isQAManager: boolean | undefined;
  subHeading: string | undefined;
  panel: 'reject' | 'excludedFromPublish' | undefined;
  rejection: FeedbackApproval | undefined;
  showRejection = false;
  rejectionReason = '';
  userId: string | undefined;
  managerApproved: FeedbackApproval | undefined;
  navigatedFromGlobalSearch: any;
  user: { objectID: string; roles: string[] } | null | undefined;
  revalidationReviewQAManager!: boolean;
  ReviewView = ReviewView;
  ReviewStage = ReviewStage;


  constructor(private service: ReviewService,
    route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private caseSplit: CaseSplitPipe) {
    this.reviewId = route.snapshot.params.id;
    this.stage = route.snapshot.queryParams.stage;
    this.cohortId = route.snapshot.queryParams.cohortId;
    this.navigatedFromGlobalSearch = route.snapshot.queryParams.globalSearch;
  }

  ngOnInit() {

    this.getUserInReview();
    this.load();

  }

  getUserInReview() {
    return this.userService.getUser().subscribe(user => {
      this.user = user;
      if (user) {
        this.userId = user.objectID;
        this.isQA = user.roles.indexOf('RevalidationReviewQA') > -1;
        this.isQAManager = user.roles.indexOf('RevalidationReviewQAManagers') > -1;
      }
    });
  }

  setexcludedFromPublish(shouldExclude: boolean | undefined) {
    if (shouldExclude === undefined) {
      return;
    }

    this.excluding = true;
    this.service.excludedFromPublish(this.reviewId, shouldExclude).subscribe(() => {
      this.excluding = false;
      this.review.excludedFromPublish = shouldExclude;
      this.panel = undefined;
    });
  }

  togglePanel(panel: 'reject' | 'excludedFromPublish') {
    // if (this.panel === panel) {
    //   this.panel = undefined;
    // } else {
      this.panel = panel;
      if (panel === 'reject') {
        setTimeout(() => { this.rejectionReasonRef.nativeElement.focus(); });
      }
    // }

  }

  get role() {
    if (this.isQAManager) {
      return 'QA Manager';
    }
    if (this.isQA) {
      return 'QA';
    }
    return 'Customer services';
  }


  get currentUserIsFeedbackAuthor() {
    return this.review.feedback.author?.userId === this.userId;
  }


  load() {

    this.loading = true;
    this.service.getReview(this.reviewId).subscribe(data => {
      this.review = data;

      console.log("user role is", this.role);
      this.rejection = this.review.feedback.feedbackApprovals?.find(approval => approval.feedbackReviewDecision === FeedbackConfirmation.Rejected
          && approval.feedbackReviewerRole === ReviewerRole.QualityAssuranceManager);
      this.showRejection = !!this.rejection;

      this.managerApproved = this.review.feedback.feedbackApprovals
        ?.find(approval => approval.feedbackReviewDecision === FeedbackConfirmation.Confirmed
          && approval.feedbackReviewerRole === ReviewerRole.QualityAssuranceManager);

      this.review.isFeedbackEditable = !!(!this.managerApproved && (
        (this.review.stage === ReviewStage.AwaitingFeedbackApprovalByQualityAssurer &&
          (this.isQA || this.isQAManager)) ||
        (this.review.stage === ReviewStage.QualityAssuranceCompleted && (this.isQAManager)) ||
        (this.review.stage === ReviewStage.CoreCriteriaNotMet && (this.isQAManager) && !this.review.inRemediation)
      ));

      console.log("review.stage", this.review.stage);
      this.subHeading = this.caseSplit.transform(this.review.stageAsString);
      if (this.managerApproved) {
        this.subHeading += ' (Manager approved)';
      }

      this.shouldexcludedFromPublish = this.review.excludedFromPublish;
      this.selectedFeedback = this.review.feedback;
      this.loading = false;

    });
  }

  accept() {
    if (this.review.hasEdits) {
      this.saving = true;
      this.service.saveFeedback(this.reviewId, this.review.feedbackEdit).subscribe(data => {
        const feedbackEdit = this.review.feedbackEdit ??= {} as any;
        const author = feedbackEdit.author ??= {} as any;
        author.userId = this.userId;
        this.review.feedback = cloneDeep(this.review.feedbackEdit);
        this.selectedFeedback = this.review.feedback;
        this.review.feedback.id = data;
        this.review.hasEdits = false;
        this.saving = false;
      }, error => {
        this.saving = false;
      });
    } else {
      if (!this.review.feedback.id) {
        console.error('Cannot approve feedback because its ID is missing.');
        return;
      }
      this.approving = true;
      this.service.approveFeedback(this.review.id, this.review.feedback.id).subscribe(() => {
        this.approving = false;
        this.exit();
      }, error => { this.approving = false; });
    }


  }


  reject() {
    if (!this.review.feedback.id) {
      console.error('Cannot reject feedback because its ID is missing.');
      return;
    }
    this.rejecting = true;
    this.service.rejectFeedback(this.review.id, this.review.feedback.id, this.rejectionReason).subscribe(() => {
      this.rejecting = false;
      this.exit();
    }, error => { this.rejecting = false; });
  }

  toggleChat() {
    this.chatVisible = !this.chatVisible;
    if (this.chatVisible) {
      this.chatOffset = 0;
    } else {
      this.chatOffset = -400;
    }
  }



  toggleHelp() {
    this.helpVisible = !this.helpVisible;
  }


  exit(filter: any = {}) {
    if (this.navigatedFromGlobalSearch) {
      this.router.navigate([`./revalidation/review/`]);
    } else if ((filter.excludedFromPublish) ||
      (filter.reviewView === 2) || (filter.reviewView === 3) || (filter.reviewView === 5) || (filter.reviewView === 6)) {
      this.router.navigate(['/revalidation/review/qaCohort', this.cohortId], { queryParams: filter });
      // this.router.navigate([`./revalidation/review/${this.stage}Cohort`, this.cohortId], { queryParams: filter });
    }
    else {
      this.router.navigate([`./revalidation/review/${this.stage}Cohort`, this.cohortId]);
    }

  }

  onSelectedSection(section: RevalidationItemTypeConfig | FeedbackSection | undefined) {
    this.selected = section;
    if (section && 'type' in section && section.type !== undefined) {
      this.items = this.review.entries.filter(entry => entry.type === section.type);
      this.selectedIndex = 0;
    } else {
      this.items = this.review.entries;
      if (section) {
        this.selectedIndex = 0;
      }
    }

  }



}
